/**
 * useStudentActivitiesData — l'appel de l'onglet Activités de l'élève.
 *
 * Un seul appel, celui de la branche élève de `TodoListScreen.js` : `authService.getUser`, le compte
 * entier, que le réducteur `currentUser` range (le view-model lit `todo_activities`, `activities`,
 * `xp`). Il part :
 * - sur la flèche de la barre de titre (`:674-688`) ;
 * - à chaque retour sur l'onglet, sauf le premier (`:150-163` : au premier, `BottomTabsNavigator`
 *   vient de charger le compte — il le charge toujours, la coquille de l'élève est montée dessous),
 *   sous la garde partagée avec l'accueil (`useAccountRereadOnReturn`) : une lecture en vol ou partie
 *   il y a moins de 30 s suffit.
 *
 * Le tirer-pour-rafraîchir du legacy relançait aussi les contrôles à venir (`:1166-1174`) pour le
 * widget de l'accueil ; ce widget n'est plus sur cet onglet, l'appel ne l'est plus non plus.
 */
import { useCallback } from "react"
import { useDispatch } from "react-redux"

import { apiRequest } from "../../../../../../data/redux/actions/api"
import { authService } from "../../../../../../data/services/authService"
import { useAccountRereadOnReturn } from "../useAccountRereadOnReturn"

export function useStudentActivitiesData() {
    const dispatch = useDispatch()

    const refresh = useCallback(() => {
        dispatch(apiRequest(authService.getUser) as never)
    }, [dispatch])

    useAccountRereadOnReturn()

    return { refresh }
}
